<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    // this.$wait.end("change pages");
  },
  watch: {
    $route() {
      // this.$wait.start("change pages");
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/public.scss";
</style>
